<template>
  <tr @click="toggleIndividualContact()" 　style="height: 43px;">
    <td>{{ rowNumber }}</td>
    <td>{{ formatDate(contact.repliedDate) }}</td>
    <!-- <td>{{ formatDate(contact.receiver.joinedDate) }}</td> -->
    <td>{{ contact.receiver.last_name }} {{ contact.receiver.name }}</td>
    <td>{{ contact.jobDetail }}</td>
    <td>
      <span class="user-response">{{ contact.user_response }}</span>
    </td>
    <!-- <td><StatusBox :status="contact.receiver.status" /></td> -->
    <td style="text-align: center !important; min-width: 60px !important;">
      <div
        class="circle cv-circle mr-2"
        :class="{ 'green-tab': contact.receiver.cv }"
      ></div>
      <div
        class="circle"
        :class="{ 'green-tab': contact.receiver.resume }"
      ></div>
    </td>
    <!-- <td style="text-align: center !important; min-width: 60px !important;">
      
    </td> -->
    <td style="text-align: center !important;">
      <input
        type="checkbox"
        name="hide"
        @click.stop
        v-model="contact.isHidden"
        @change="hideItem()"
        style="width: 20px;height:20px"
        :value="true"
      />
    </td>
    <td style="text-align: center !important;">
      <span class="contact-history-link" @click.stop="openContactHistory()">
        <img
          src="@/assets/images/newTab.png"
          alt="送受信履歴"
          class="contact-history-icon"
        />
        送受信<br />履歴
      </span>
    </td>
    <td></td>
    <!-- <IndividualContact
      v-if="showIndividualContact"
      :applicantIndex="index"
      :applicant_id="contact.receiver._id"
      :showIndividualContact="showIndividualContact"
      @cancel="toggleIndividualContact"
    /> -->
  </tr>
</template>

<script>
import moment from 'moment';
import StatusBox from './StatusBox.vue';
import IndividualContact from '../IndividualContact.vue';
export default {
  name: 'ReceivedContactRow',
  props: ['receivedContact', 'index', 'rowNumber', 'applicantIndex'],
  components: { StatusBox, IndividualContact },
  data() {
    return {
      contact: this.receivedContact,
      showIndividualContact: false,
    };
  },
  methods: {
    toggleIndividualContact() {
      this.showIndividualContact = !this.showIndividualContact;
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    hideItem() {
      this.$emit('hideItem', this.contact);
    },
    openIndividualContact(applicant) {
      let routeUrl = this.$router.resolve({
        path: `/applicant/${applicant._id}/contact`,
      });
      // Open in a new tab
      window.open(routeUrl.href, '_blank');
    },
    openContactHistory() {
      let routeUrl = this.$router.resolve({
        path: `/applicant/${this.contact.receiver._id}/contact`,
      });
      // Open in a new tab
      window.open(routeUrl.href, '_blank');
    },
  },
};
</script>

<style scoped>
.user-response {
  display: inline-block;
  width: 130px;
  height: 32px;
  border-radius: 3px;
  background: #787878;
  color: #fff;
  padding: 5px;
  text-align: center;
}

.gray-tab {
  background-color: #787878;
}

td {
  text-align: center !important;
  font-size: 14px !important;
  color: #3c3c3c !important;
}

tr {
  cursor: pointer;
}

.contact-history-link {
  color: #000;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.contact-history-link:hover {
  color: #333;
  text-decoration: underline;
}

.contact-history-icon {
  font-size: 61px;
  color: #000;
  width: 61px;
  height: 61px;
}
</style>
